// re.rejouis.fr — ÉCRAN DE RÉSOLUTION du deep-link /reprendre/<handle>.
// Point d'entrée du bouton « Je revends ce produit » posé sur les fiches
// rejouis.fr : on résout le handle en produit du catalogue de reprise, puis on
// enchaîne directement sur le questionnaire d'état.
//
// L'éligibilité est tranchée côté serveur (catalog.js applique _eligibilite.js
// + la liste d'exclusion Airtable) : ici on se contente d'afficher le verdict.
import { useEffect, useState } from 'react';
import { EcranHeader, Icons, Spinner, Sticker } from '../components/ui.jsx';
import { produitParHandle } from '../lib/api.js';

export default function Reprendre({ go, handle, onChoisir }) {
  // 'chargement' | 'refuse' | 'introuvable'
  const [etat, setEtat] = useState('chargement');

  useEffect(() => {
    if (!handle) { setEtat('introuvable'); return; }
    let vivant = true;
    produitParHandle(handle)
      .then((r) => {
        if (!vivant) return;
        // Produit éligible → on passe la main au parcours normal (écran état).
        if (r.eligible && r.produit) onChoisir(r.produit);
        else setEtat('refuse');
      })
      .catch(() => { if (vivant) setEtat('introuvable'); });
    return () => { vivant = false; };
  }, [handle]);

  if (etat === 'chargement') {
    return (
      <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <Spinner size={22} label="On charge ton modèle…" />
      </div>
    );
  }

  // Refus d'éligibilité : matière poreuse, cosmétique, exclusion back-office…
  // Même mise en forme que les autres sorties « pas de crédit » (cf. Etat.jsx).
  if (etat === 'refuse') {
    return (
      <div className="no-scrollbar anim-fade" style={{ height: '100%', overflow: 'auto', padding: '8px 0 40px' }}>
        <EcranHeader titre="" onBack={() => go('accueil')} />
        <div style={{ padding: '8px 22px 0', textAlign: 'center' }}>
          <div style={{ display: 'flex', justifyContent: 'center' }}><Sticker nom="mains-coeur" size={92} anim="pop" /></div>
          <h2 className="t-display" style={{ fontSize: 24, margin: '14px 0 0' }}>On ne reprend pas ce modèle</h2>
          <p style={{ fontSize: 13.5, color: 'var(--stone)', margin: '8px 0 0', lineHeight: 1.6 }}>
            Certaines matières ne se reconditionnent pas proprement, et d’autres modèles
            ne sont pas repris en ce moment. Ne le jette pas pour autant : tu peux nous en
            faire don, on le recycle comme il faut.
          </p>
        </div>
        <div style={{ padding: '20px 18px 0', display: 'flex', flexDirection: 'column', gap: 8 }}>
          <button className="btn btn-primary btn-block" onClick={() => go('don')}>Faire un don</button>
          <button className="btn btn-tertiary btn-block" onClick={() => go('catalogue', { focus: true })}>Chercher un autre modèle</button>
        </div>
      </div>
    );
  }

  // Handle inconnu du catalogue, ou réseau en vrac.
  return (
    <div style={{ padding: '60px 18px', textAlign: 'center' }}>
      <p style={{ color: 'var(--stone)', fontSize: 14, lineHeight: 1.6 }}>
        On n’a pas retrouvé ce modèle. Cherche-le par son nom, ou photographie-le.
      </p>
      <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 8 }}>
        <button className="btn btn-primary btn-block" onClick={() => go('catalogue', { focus: true })}>Chercher un modèle</button>
        <button className="btn btn-tertiary btn-block" onClick={() => go('accueil')}>Retour à l’accueil</button>
      </div>
    </div>
  );
}
